import Tooltip from "@mui/material/Tooltip"

interface Props {
    haEnabled: boolean
    numNodes: number
    mySqlLocal: boolean
    numMySqlBackups: number
    numImages: number
    imageSize: number
    loggingEnabled: boolean
    handleHaEnabled: React.ChangeEventHandler<HTMLInputElement>
    handleLogging: React.ChangeEventHandler<HTMLInputElement>
    handleNumNodes: React.ChangeEventHandler<HTMLInputElement>
    handleNumImages: React.ChangeEventHandler<HTMLInputElement>
    handleImageSize: React.ChangeEventHandler<HTMLInputElement>
    handleMySqlLocal: React.ChangeEventHandler<HTMLInputElement>
    handleNumMySqlBackups: React.ChangeEventHandler<HTMLInputElement>
}

interface Tooltips {
    title: string
    visible?: boolean
}

function StorageForm({haEnabled, numNodes, numImages, imageSize, loggingEnabled, mySqlLocal, numMySqlBackups, handleHaEnabled, handleLogging, handleNumNodes, handleNumImages, handleImageSize, handleMySqlLocal, handleNumMySqlBackups}: Props){
    return <>
        <label htmlFor="numberOfNodes" className="form-label">Number of Nodes</label>
        <InfoTooltip title="The number of VMs or other objects, also known as Workload Elements (WLEs), that Morpheus will discover or manage." />
        <div className="input-group">
            <input type="text" id="numberOfNodes" className="form-control" aria-labelledby="numberOfNodes" min="0" step="100" aria-describedby="numberOfNodesAddon" defaultValue={numNodes} onChange={handleNumNodes}></input>
            <span className="input-group-text" id="numberOfNodesAddon">#</span>
        </div>
        
        <div className="row">
            <div className="col">
                <label htmlFor="numberOfImages" className="form-label">Image Uploads</label>
                <InfoTooltip title="Morpheus can store images such as OVAs and VMDKs, which can be deployed to multiple clouds.  Each of these require space on the appliance or shared storage.  Templates and other images sync'd from vCenter or other technologies do not need to be included." />
                <div className="input-group">
                    <input type="number" id="numberOfImages" className="form-control" aria-labelledby="numberOfImages" aria-describedby="numberOfImagesAddon" min="0" step="1" defaultValue={numImages} onChange={handleNumImages}></input>
                    <span className="input-group-text" id="numberOfImagesAddon">#</span>
                </div>
            </div>
            <div className="col">
                <label htmlFor="sizeOfImages" className="form-label">Image Size</label>
                <InfoTooltip title="Average size of each Image Upload." />
                <div className="input-group">
                    <input type="number" id="sizeOfImages" className="form-control" aria-labelledby="sizeOfImages" aria-describedby="sizeOfImagesAddon" min="0" step="1" defaultValue={imageSize} onChange={handleImageSize}></input>
                    <span className="input-group-text" id="sizeOfImagesAddon">GB</span>
                </div>
            </div>
        </div>
        <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" role="switch" id="mySqlLocal" defaultChecked={mySqlLocal} onChange={handleMySqlLocal}/>
            <label className="form-check-label" htmlFor="mySqlLocal">MySQL Local Backups?</label>
            <InfoTooltip title="Morpheus by default will save database backups to the appliance(s). Disable this option if you plan to configure Morpheus to save backups to an external location, such as AWS S3, Azure Storage Account, NFS share, etc." />
        </div>
        <label style={{ display: mySqlLocal ? "inline" : "none" }} htmlFor="numberOfMySqlBackups" className="form-label">MySQL Backup Retention</label>
        <InfoTooltip visible={mySqlLocal} title="Unless the Morpheus backups are configured to an external location, they will be saved to disk by default.  This is the number of backups to keep on disk." />
        <div className="input-group">
            <input style={{ display: mySqlLocal ? "inline" : "none" }} type="number" id="numberOfMySqlBackups" className="form-control" aria-labelledby="numberOfMySqlBackups" aria-describedby="numberOfMySqlBackupsAddon" min="0" step="1" defaultValue={numMySqlBackups} onChange={handleNumMySqlBackups}></input>
            <span style={{ display: mySqlLocal ? "inline" : "none" }} className="input-group-text" id="numberOfMySqlBackupsAddon">#</span>
        </div>
        <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" role="switch" id="haEnabled" defaultChecked={haEnabled} onChange={handleHaEnabled}/>
            <label className="form-check-label" htmlFor="haEnabled">High Availability (HA) Deployment?</label>
            <InfoTooltip title="High Availability (HA) deployments have multiple application nodes, to prevent downtime. They are usually backed by an external MySQL cluster, which is also highly available. Contact your account manager if you wish to upgrade or deploy a HA environment." />
        </div>
        <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" role="switch" id="loggingEnabled" defaultChecked={loggingEnabled} onChange={handleLogging}/>
            <label className="form-check-label" htmlFor="loggingEnabled">Logging Enabled?</label>
            <InfoTooltip title="Morpheus can gather logs from deployed instances, which will be stored on the appliance(s).  Storing the logs uses additional space." />
        </div>
    </>
}

function InfoTooltip(props: Tooltips){
    if(props.visible != false){
        return(
            <>
                &nbsp;
                <Tooltip
                    title={props.title}
                    placement="top"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                    </svg>
                </Tooltip>
            </>
        )
    }else{
        return(null)
    }
}

export default StorageForm;